import { BaseModel } from './BaseModel';

export class Utility extends BaseModel {
  static get entity() {
    return 'utilities';
  }

  static get fk() {
    return 'utility';
  }

  static fields() {
    return {
      id: this.attr(null),
      field: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      requestResetPassword(body) {
        return this.post(`/utilities/request-reset-password`, body);
      },

      saveSession(token) {
        return this.post(`/utilities/save-session`, { token });
      },

      checkExpried(body) {
        return this.post(`/utilities/check-expried`, body);
      },

      verifyCaptcha(token) {
        return this.post(`/utilities/verify-captcha`, { token });
      },

      /**
       *
       * @param {Object} params
       * @param {string} params.firstName
       * @param {string} params.lastName
       * @param {string} params.email
       * @returns
       */
      validateSignUp(params) {
        return this.post(`/utilities/signup/validate`, params, { save: false });
      },

      findUserByEmail(email) {
        return this.get(`/utilities/find-user-by-email?email=${email}`, {
          save: false
        });
      },

      /**
       *
       * @param {Object} param
       * @param {String} params.username
       * @returns
       */
      validateSignIn({ username }) {
        return this.post('/utilities/signin/validate', { username }, { save: false });
      },
      googleAuthURL() {
        return this.get(`/utilities/google-auth-url`, { save: false });
      },
      googleAuthenticate(code) {
        return this.get(`/utilities/google-authenticate?code=${code}`, { save: false });
      },
      signOutGoogle(body) {
        return this.get(`/utilities/google-logout-url`, body, { save: false });
      },
      /**
       * Fetch an image through the proxy
       * @param {string} imageUrl - The original image URL to proxy
       * @returns {Promise<Blob>} The image blob
       */
      proxyImage(imageUrl) {
        return this.get(`/utilities/proxy-image?url=${encodeURIComponent(imageUrl)}`, {
          responseType: 'blob',
          save: false,
          dataTransformer: (response) => response
        });
      },
      /**
       * Get a proxy URL for an image
       * @param {string} imageUrl - The original image URL to proxy
       * @returns {string} The proxied image URL
       */
      getProxyImageUrl(imageUrl) {
        if (!imageUrl) return '';
        const baseUrl = process.env.VUE_APP_BASE_URL;
        return `${baseUrl}/utilities/proxy-image?url=${encodeURIComponent(imageUrl)}`;
      },
      searchResult(query) {
        return this.get(`/utilities/search`, { params: { query } }, { save: false });
      },

      /**
       * Get a proxy URL for a file
       * @param {string} fileUrl - The original file URL to proxy
       * @param {string} filename - The desired filename for the downloaded file
       * @returns {string} The proxied file URL
       */
      getProxyFileUrl(fileUrl, filename) {
        if (!fileUrl) return '';

        const baseUrl = process.env.VUE_APP_BASE_URL;
        const params = new URLSearchParams({
          url: fileUrl,
          filename: filename
        });

        return `${baseUrl}/utilities/proxy-file?${params.toString()}`;
      }
    }
  };
}

export default Utility;
